import React from "react";
import { Col, Container, Row } from "reactstrap";
import WhyIpoFirst from "../assets/images/WhyipoOne.png"
import WhyIpoSecond from "../assets/images/WhyIpoTwo.png";
import WhyIpoThird from "../assets/images/WhyIpoThird.png";
import WhyIpoFourth from "../assets/images/WhyIpoFour.png";
import WhyIpoFifth from "../assets/images/WhyIpoFive.png";
import WhyIpoSixth from "../assets/images/WhyIpoSix.png";

export default function WhyIpo(props) {
  const determineImage = (index) => {
    switch (index) {
      case 1:
        return <img className="img-align" src={WhyIpoFirst} alt="img-1"/>;
      case 2:
        return <img className="img-align" src={WhyIpoSecond} alt="img-2"/>;
      case 3:
        return <img className="img-align" src={WhyIpoThird} alt="img-3"/>;
      case 4:
        return <img className="img-align" src={WhyIpoFourth} alt="img-4"/>;
      case 5:
        return <img className="img-align" src={WhyIpoFifth} alt="img-5"/>;
      case 6:
        return <img className="img-align" src={WhyIpoSixth} alt="img-6"/>;
    }
  }
  return (
    <div className="why-icm-main">
      <Container className="why-icm-sub-main">
        <p className="main-title text-center">
          What we like about {props?.mldAssetDetails?.displayName} ?
        </p>
        {props?.mldAssetDetails?.whyInvest?.split('|').length > 0 &&
          <Row className="">
            {props.mldAssetDetails?.whyInvest.split('|').map((item, index) => (
              <Col className="why-icm-item" lg={6} xl={6} sm={11} xs={11} md={11}>
                {determineImage(index + 1)}
                <p
                  className="mb-0"
                  dangerouslySetInnerHTML={
                    { __html: item }
                  }
                />
              </Col>
            ))}
          </Row>
        }
      </Container>
    </div>
  )
}